import styled from 'styled-components';
import checkRoundedFilled from '../../icons/check-rounded-filled.svg';

export default styled.div`
  background: url(${checkRoundedFilled}) center no-repeat;
  background-size: contain;
  width: 4.75rem;
  height: 4.75rem;
  margin-bottom: 1rem;
`;
